<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="formatForm" :refresh-key="refreshKey" :show-expand="$route.name == 'auditEditor'">
        <template v-slot:expand="{ item, refreshKey }">
            <component :is="format" v-if="$route.name == 'auditEditor'" :item-id="item.id" :refresh-key="refreshKey" :filter="filter" />
        </template>
    </table-base>
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                formatForm: () => import('../forms/FormatForm'),
                format: () => import('../editViews/Format'),
                headers: [
                    { text: 'Name', value: 'name' },
                    { text: 'C Sharp Format', value: 'cSharpFormat' },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    items: []
                },
                sorting: [
                    { column: "name", direction: "ascending" },
                ],
                itemsField: 'formats',
                editPageName: 'format',
                apiMethod: 'Formats',
                claimName: 'Formats',
                formTitle: 'Format',
                excelTitle: 'Formats',
                hasEditPage: true,
            }
        },
    };
</script>
